import { render, staticRenderFns } from "./prizeentity.vue?vue&type=template&id=05cfaf5c&scoped=true"
import script from "./prizeentity.vue?vue&type=script&lang=js"
export * from "./prizeentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cfaf5c",
  null
  
)

export default component.exports